import { ListItemText, SxProps, Theme } from '@mui/material'
import { useTranslation } from 'react-i18next'


interface Props {
  sx?: SxProps<Theme>
}

const LanguagePicker  = (props: Props) => {
  const { t, i18n } = useTranslation()
  const targetLanguage = t('common.targetLanguage')

  const changeLanguage = () => {
    void (async () => {
      await i18n.changeLanguage(targetLanguage)
    })()
  }

  return (
    <ListItemText sx={{ ...props.sx, textTransform: 'uppercase' }} onClick={changeLanguage}>
      {targetLanguage}
    </ListItemText>
  )
}

export default LanguagePicker
